import { createAction, props, createReducer, on } from '@ngrx/store';
import { FlybackReducer } from '../models/flyback-reducer.model';

// Action definitions using createAction
export const updateFlybackEligibleProducts = createAction(
  '[Flyback] Update Flyback Eligible Products',
  props<{ payload: any }>()
);

export const flyBackFlightDate = createAction(
  '[Flyback] Flyback Flight Date',
  props<{ payload: string }>()
);

export const updateCurrentStep = createAction(
  '[Flyback] Update Current Step'
);

export const decrementCurrentStep = createAction(
  '[Flyback] Decrement Current Step'
);

export const updateFlightQuote = createAction(
  '[Flyback] Update Flight Quote',
  props<{ payload: any }>()
);

export const updateFlybackBookingStatus = createAction(
  '[Flyback] Update Flyback Booking Status',
  props<{ payload: boolean }>()
);

export const updateFlybackRedirect = createAction(
  '[Flyback] Update Flyback Redirect',
  props<{ payload: boolean }>()
);

export const updateFlybackCustomerDetails = createAction(
  '[Flyback] Update Flyback Customer Details',
  props<{ payload: any }>()
);

export const updateFlybackCustomerHasMarketingEnrolment = createAction(
  '[Flyback] Update Flyback Customer Has Marketing Enrolment',
  props<{ payload: boolean }>()
);

export const updateFlyBackCompleteStatus = createAction(
  '[Flyback] Update Flyback Complete Status',
  props<{ payload: boolean }>()
);

export const setFlybackMinPrice = createAction(
  '[Flyback] Set Flyback Min Price',
  props<{ payload: any }>()
);

export const updateFlybackMinDate = createAction(
  '[Flyback] Update Flyback Min Date',
  props<{ payload: string }>()
);

export const updateFlybackPromoFromUrl = createAction(
  '[Flyback] Update Flyback Promo From URL',
  props<{ payload: any }>()
);

export const updateFlybackCsMotoFromUrl = createAction(
  '[Flyback] Update Flyback CS Moto From URL',
  props<{ payload: any }>()
);

export const resetOptionalDataFlybackReducer = createAction(
  '[Flyback] Reset Optional Data Flyback Reducer'
);

export const refreshFlybackReducer = createAction(
  '[Flyback] Refresh Flyback Reducer',
  props<{ payload: any }>()
);

export const resetFlybackReducer = createAction(
  '[Flyback] Reset Flyback Reducer'
);

// Initial state
const optionalDataInitState = {
  flybackBooking: false,
  flyBackRedirect: false,
  currentStep: 0,
  outboundPrice: '',
  inboundPrice: '',
  departurePostOfficePrice: '',
  promoFromUrl: null,
  csMotoFromUrl: false,
};

const initState: FlybackReducer = {
  eligibleProducts: null,
  abcAvailable: false,
  ccdAvailable: false,
  quoteFlightRequest: {
    departureAirport: null,
    toAirport: null,
    toCity: null,
    arrivalAirport: null,
    fromAirport: null,
    fromCity: null,
    airline: null,
    airlineName: null,
    departDate: null,
    bagCount: null,
    bagItems: {
      bags: 0,
      childEquipment: 0,
      oversizeItem: 0,
    },
    flightDirection: null,
    flightNumber: null,
  },
  customerDetails: {
    firstName: '',
    lastName: '',
    emailAddress: '',
  },
  isFlybackCompleted: false,
  flybackMinDate: '',
  flybackFlightDate: '',
  ...optionalDataInitState,
};

// Reducer using createReducer and on
export const flybackReducer = createReducer(
  initState,
  on(updateFlybackEligibleProducts, (state, { payload }) => ({
    ...state,
    eligibleProducts: payload,
    abcAvailable: payload.includes('ABC'),
    ccdAvailable: payload.includes('CCD'),
  })),
  on(flyBackFlightDate, (state, { payload }) => ({
    ...state,
    flybackFlightDate: payload,
  })),
  on(updateCurrentStep, (state) => ({
    ...state,
    currentStep: state.currentStep + 1,
  })),
  on(decrementCurrentStep, (state) => ({
    ...state,
    currentStep: state.currentStep - 1,
  })),
  on(updateFlightQuote, (state, { payload }) => ({
    ...state,
    quoteFlightRequest: payload,
  })),
  on(updateFlybackBookingStatus, (state, { payload }) => ({
    ...state,
    flybackBooking: payload,
  })),
  on(updateFlybackRedirect, (state, { payload }) => ({
    ...state,
    flyBackRedirect: payload,
  })),
  on(updateFlybackCustomerDetails, (state, { payload }) => ({
    ...state,
    customerDetails: payload,
  })),
  on(updateFlybackCustomerHasMarketingEnrolment, (state, { payload }) => ({
    ...state,
    customerHasMarketingEnrolment: payload,
  })),
  on(updateFlyBackCompleteStatus, (state, { payload }) => ({
    ...state,
    isFlybackCompleted: payload,
  })),
  on(setFlybackMinPrice, (state, { payload }) => ({
    ...state,
    ...payload,
  })),
  on(updateFlybackMinDate, (state, { payload }) => ({
    ...state,
    flybackMinDate: payload,
  })),
  on(updateFlybackPromoFromUrl, (state, { payload }) => ({
    ...state,
    promoFromUrl: payload,
  })),
  on(updateFlybackCsMotoFromUrl, (state, { payload }) => ({
    ...state,
    csMotoFromUrl: payload,
  })),
  on(resetOptionalDataFlybackReducer, (state) => ({
    ...state,
    ...optionalDataInitState,
  })),
  on(refreshFlybackReducer, (state, { payload }) => ({
    ...payload,
  })),
  on(resetFlybackReducer, () => ({
    ...initState,
  }))
);
